import { render, staticRenderFns } from "./UserProperties.vue?vue&type=template&id=861c75ea"
import script from "./UserProperties.vue?vue&type=script&lang=js"
export * from "./UserProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports